import AddNewBtnPresenter from "./AddNewBtn/AddNewBtnPresenter"
import StreetLightListPresenter from "./StreetLightList/StreetLightListPresenter"

export const StreetLightList = {
    List : StreetLightListPresenter,
    AddBtn : AddNewBtnPresenter
}

export default StreetLightList